import { useTranslation } from "next-i18next";
import cx from "classnames";

import { IPaymentDataProps } from "../types";

import styles from "./OfferPrice.module.scss";

const OfferPrice = ({
  price,
  period,
  savings,
  savingsLabel,
}: IPaymentDataProps) => {
  const { t } = useTranslation("translations");

  return (
    <div className={styles.container}>
      <span
        className={cx(styles.savings, {
          [styles.savingsLabel]: savingsLabel,
        })}
      >
        {savingsLabel
          ? savingsLabel
          : savings && `${savings} ${t("web_currency")}`}
      </span>
      <span className={styles.price}>{price}</span>
      <span className={styles.currency}>{`${t("web_currency")}${t(
        `web_payment_period_${period}`
      )}`}</span>
    </div>
  );
};

export default OfferPrice;
